__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/67fbe5d/_next/";